import { reactive, toRefs } from 'vue'
import ActAdminApi from '@/helpers/actAdminApi'

export function useActAdminApi() {
  const actApiInst = new ActAdminApi()
  const actApiInstances = reactive({
    actUserApi: null,
    actPurchasesApi: null,
    actActivationsApi: null,
    actMappingApi: null,
    actFinancesApi: null,
    actResellersApi: null,
    actReportsApi: null,
    actNotesApi: null,
    actCatalogApi: null,
    actPaymentCouponsApi: null
  })

  const initApiInst = async () => {
    await getUserApi()
    await getPurchasesApi()
    await getActivationsApi()
    await getMappingApi()
    await getFinancesApi()
    await getResellersApi()
    await getReportsApi()
    await getNotesApi()
    await getCatalogApi()
    await getPaymentCouponsApi()
    await actApiInst.updateFbToken()
  }

  const getUserApi = async () => {
    if (actApiInst) {
      actApiInstances.actUserApi = await actApiInst.userApi()
    }
  }

  const getPurchasesApi = async () => {
    if (actApiInst) {
      actApiInstances.actPurchasesApi = await actApiInst.purchasesApi()
    }
  }

  const getActivationsApi = async () => {
    if (actApiInst) {
      actApiInstances.actActivationsApi = await actApiInst.activationsApi()
    }
  }

  const getMappingApi = async () => {
    if (actApiInst) {
      actApiInstances.actMappingApi = await actApiInst.mappingApi()
    }
  }

  const getFinancesApi = async () => {
    if (actApiInst) {
      actApiInstances.actFinancesApi = await actApiInst.financesApi()
    }
  }

  const getResellersApi = async () => {
    if (actApiInst) {
      actApiInstances.actResellersApi = await actApiInst.resellersApi()
    }
  }

  const getReportsApi = async () => {
    if (actApiInst) {
      actApiInstances.actReportsApi = await actApiInst.reportsApi()
    }
  }

  const getNotesApi = async () => {
    if (actApiInst) {
      actApiInstances.actNotesApi = await actApiInst.notesApi()
    }
  }

  const getCatalogApi = async () => {
    if (actApiInst) {
      actApiInstances.actCatalogApi = await actApiInst.catalogApi()
    }
  }

  const getPaymentCouponsApi = async () => {
    if (actApiInst) {
      actApiInstances.actPaymentCouponsApi = await actApiInst.paymentCouponsApi()
    }
  }

  return {
    initApiInst,
    ...toRefs(actApiInstances)
  }
}
